export default {
    id: 0,
    isNew: true,
    name: "",
    email: "",
    password: null,
    passwordRepeat: null
}
